<app-menu></app-menu>

<!-- Hero Section -->
<div [class.hero-red]="selectedProduct === 'playout'" [class.hero-black]="selectedProduct === 'vpn'"
    class="hero-custom uk-light uk-section uk-flex uk-flex-middle">
    <div class="rain-bg"></div>
    <div class="uk-container uk-text-center" style="position: relative; z-index: 2;">
        <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            Nossos Produtos
        </h1>
        <p class="uk-text-large" style="opacity: 0.9;" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
            Soluções críticas para todos sectores empresariais
        </p>
    </div>
</div>

<!-- Modern Selector Buttons -->
<div class="uk-section uk-padding-remove-bottom product-selector-section">
    <div class="uk-container">
        <div class="uk-flex uk-flex-center">
            <div class="premium-segment-control" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 100">
                <button class="segment-btn" [class.active]="selectedProduct === 'playout'"
                    (click)="setProduct('playout')">
                    <span uk-icon="icon: tv; ratio: 0.8" class="uk-margin-small-right"></span>
                    FluxoPlayOut
                </button>
                <button class="segment-btn" [class.active]="selectedProduct === 'vpn'" (click)="setProduct('vpn')">
                    <span uk-icon="icon: lock; ratio: 0.8" class="uk-margin-small-right"></span>
                    AngloAn VPN
                </button>
                <div class="segment-indicator" [class.pos-vpn]="selectedProduct === 'vpn'"></div>
            </div>
        </div>
    </div>
</div>

<!-- Products Showcase -->
<div class="uk-section products-showcase-section">
    <div class="uk-container">
        <div class="uk-flex uk-flex-center">

            <!-- FluxoPlayOut -->
            <div *ngIf="selectedProduct === 'playout'" class="product-animate-wrapper uk-width-3-4@m">
                <div class="premium-product-card playout-theme">
                    <div class="card-glow"></div>
                    <div class="card-content uk-grid uk-grid-collapse uk-child-width-1-2@s" uk-grid>
                        <div class="product-info uk-padding-large">
                            <div class="product-badge red-badge">AUTOMAÇÃO TV</div>
                            <div class="icon-box red-icon">
                                <span uk-icon="icon: tv; ratio: 2.5"></span>
                            </div>
                            <h2 class="product-title">FluxoPlayOut</h2>
                            <p class="product-desc">A solução definitiva para exibição e automação de canais de TV e
                                WebTV. Gerencie sua programação com precisão absoluta e estabilidade 24/7.</p>

                            <ul class="premium-features">
                                <li><span uk-icon="icon: check"></span> Exibição em 4K e Full HD</li>
                                <li><span uk-icon="icon: check"></span> Agendamento inteligente de playlists</li>
                                <li><span uk-icon="icon: check"></span> Sobreposição de gráficos</li>
                                <li><span uk-icon="icon: check"></span> Compatível com NDI e SDI</li>
                            </ul>

                            <a href="https://playout.fluxo-digital.com/" class="premium-btn btn-red">Saber Mais <span
                                    uk-icon="arrow-right"></span></a>
                        </div>
                        <div class="product-visual playout-visual uk-flex uk-flex-middle uk-flex-center">
                            <img src="img/fluxoplayout-demo.png" alt="FluxoPlayOut Interface" class="product-screenshot">
                        </div>
                    </div>
                </div>
            </div>

            <!-- AngloAn VPN -->
            <div *ngIf="selectedProduct === 'vpn'" class="product-animate-wrapper uk-width-3-4@m">
                <div class="premium-product-card vpn-theme">
                    <div class="card-glow dark-glow"></div>
                    <div class="card-content uk-grid uk-grid-collapse uk-child-width-1-2@s" uk-grid>
                        <div class="product-info uk-padding-large">
                            <div class="product-badge dark-badge">VPN PRIVADA</div>
                            <div class="icon-box dark-icon">
                                <span uk-icon="icon: lock; ratio: 2.5"></span>
                            </div>
                            <h2 class="product-title">AngloAn VPN</h2>
                            <p class="product-desc">Segurança de nível militar para sua navegação. Proteja seus dados e
                                acesse conteúdos globais com a VPN mais rápida de Angola.</p>

                            <ul class="premium-features">
                                <li><span uk-icon="icon: check"></span> Criptografia AES-256</li>
                                <li><span uk-icon="icon: check"></span> Sem registros (No-Logs)</li>
                                <li><span uk-icon="icon: check"></span> Servidores otimizados</li>
                                <li><span uk-icon="icon: check"></span> Multi-dispositivos</li>
                            </ul>

                            <a href="http://angolanvpn.com/" target="_blank" class="premium-btn btn-dark">Acessar VPN
                                <span uk-icon="arrow-right"></span></a>
                        </div>
                        <div class="product-visual vpn-visual uk-flex uk-flex-middle uk-flex-center">
                            <div class="visual-abstract">
                                <div class="abstract-shield"></div>
                                <span uk-icon="icon: world; ratio: 5" class="visual-icon"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- CTA Section -->
<div class="cta-section uk-section">
    <div class="uk-container uk-text-center">
        <div class="premium-cta-box" uk-scrollspy="cls: uk-animation-scale-up">
            <div class="cta-glow"></div>
            <div class="light-particles">
                <div class="particle p1"></div>
                <div class="particle p2"></div>
                <div class="particle p3"></div>
                <div class="particle p4"></div>
                <div class="particle p5"></div>
                <div class="particle p6"></div>
                <div class="particle p7"></div>
                <div class="particle p8"></div>
                <div class="particle p9"></div>
                <div class="particle p10"></div>
            </div>
            <div class="cta-content">
                <h2>Crie o Futuro do seu Negócio</h2>
                <p>Nossa equipe está pronta para desenvolver a tecnologia ideal para o seu projecto específico.</p>
                <a href="https://wa.me/244937754502/?text=Olá%2C%20estou%20interessado%20em%20serviço%20vosso%2C%20há%20alguém%20disponivel%20agora%20para%20me%20atender%3F"
                    target="_blank" class="uk-button uk-button-default cta-btn">Fale com Especialistas</a>
            </div>
        </div>
    </div>
</div>

<app-rodape></app-rodape>